import { useCallback, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import prepareQualificationUpload from './prepareQualificationUpload';

export default function useQualificationUpload() {
  const [isConverting, setIsConverting] = useState(false);
  const [fileError, setFileError] = useState('');
  const selection = useRef(0);
  useEffect(
    () => () => {
      selection.current += 1;
    },
    []
  );

  const selectFile = useCallback(async (file, onReady) => {
    if (!file) return;
    const current = ++selection.current;
    setIsConverting(true);
    setFileError('');
    try {
      const converted = await prepareQualificationUpload(file);
      if (current === selection.current) onReady(converted);
    } catch (error) {
      if (current === selection.current) {
        const message = 'Could not convert this photo. Please choose another image or export it as JPEG.';
        setFileError(message);
        toast.error(message);
      }
    } finally {
      if (current === selection.current) setIsConverting(false);
    }
  }, []);

  const cancelConversion = useCallback(() => {
    selection.current += 1;
    setIsConverting(false);
    setFileError('');
  }, []);
  return { selectFile, cancelConversion, isConverting, fileError };
}
